import React from 'react';

import { FlexRow } from 'ui-components/components/flex';

import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import { OrderOverviewSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import SectionTitle from '../../../tab-section/title';
import { ShipmentItemsExpanderContent } from './shipment-items-expander-content';

import messages from './messages';
import style from './style.module.less';

export const ShipmentItems = () => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.expandableSectionAriaLabel}
      contentClassName={style['order-items-section-content']}
      headerContent={
        <FlexRow className={style['order-items-section-header']}>
          <SectionTitle messageDescriptor={messages.sectionTitle} />
        </FlexRow>
      }
      sectionContent={<ShipmentItemsExpanderContent />}
      sectionId={OrderOverviewSectionId.OrderItems}
    />
  );
};
